<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center justify-space-between" xs12 mt-3>
          <h1 class="headline">{{ $t('appeals.appeals') }}</h1>
          <div class="d-flex align-center">
            <v-btn
              v-if="
                $can('add_appeals') &&
                  $can('appeals')
              "
              color="warning"
              class="mr-2"
              large
              depressed
              @click="dialog = true"
            >
              {{ $t('common.button.add') }}
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>

    <appeals-table
      class="mt-5"
      :updated="updated"
      @update-error="
        snack = {
          value: true,
          color: 'error',
          message: $t('common.errors.APIerror'),
        }
      "
      @updated="
        snack = {
          value: true,
          color: 'success',
          message: $t('common.saved'),
        }
      "
    />

    <appeal-dialog
      v-model="dialog"
    />
    
    <v-snackbar v-model="snack.value" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import AppealsTable from '@/components/appeals/AppealsTable.vue';
import AppealDialog from '@/components/appeals/AppealDialog.vue';

export default {
  components: { AppealsTable, AppealDialog },
  data: () => ({
    dialog: false,
    updated: false,
    snack: {
      value: false,
      color: '',
      message: '',
    },
  }),
  methods: {
    onUpdate({ success }) {
      if (!success) {
        this.snack = {
          value: true,
          color: 'error',
          message: this.$t('common.errors.APIerror'),
        };

        return;
      }

      this.dialog = false;
      this.updated = true;
    },
  },
};
</script>

<style></style>
